import React from "react";
import Sambe from "../../../images/Sambe.jpg";
import EngagementSplitPage from "../../ui/EngagementSplitPage";

const PlantKindness = () => (
  <EngagementSplitPage title="Project Plant Kindness 2.0" image={Sambe} imageAlt="Plant Kindness">
    <p>
      Celebrating 75 glorious years of independent India, KU partnered with the MAD Foundation & the Snehavardhini Social Trust, to plant 1,00,000 fruit trees in 41 Indian villages.
    </p>
    <p className="font-display text-xl font-semibold text-ku-royal">
      1,00,000 fruit trees - 41 villages - 3790+ households with a &apos;fruitful future&apos;.
    </p>
    <p>
      The Sustainable Green Initiative provided us with the plants & ensured safe & timely delivery of the same. A team of 100+ &apos;kind&apos; volunteers, from the Palghar area of Mumbai, participated in this drive of kindness with KU
    </p>
    <h3 className="font-display text-xl font-bold text-ku-royal">The USP?</h3>
    <p>
      Our volunteers didn&apos;t till the soil and plant the seeds for the villagers! Instead, they provided the raw material & guided the villagers in planting the fruit seeds by themselves.
    </p>
    <p>
      This novel approach helped the villagers:
      <br />
      Develop a sustainable skillset,
      <br />
      Gain self-confidence,
      <br />
      Consume nutritious fruits, <br /> Earn additional source of long-term income & <br />
      Gift their future generations a healthier & greener place to live in.
    </p>
    <p>
      Indeed a wonderful approach to &apos;balancing self-interest with greater good&apos;!
    </p>
  </EngagementSplitPage>
);

export default PlantKindness;
